/**
 * Credit-Schaetzung je Channel fuer Wizard-Schritt 2. Der estimate-Endpunkt
 * liefert nur eine Gesamtsumme (pairs + credits_estimated), deshalb wird je
 * Channel einzeln geschaetzt statt die Gesamtsumme heuristisch aufzuteilen.
 */

import { useQuery } from '@tanstack/react-query'

import { estimateRun } from '@/lib/api/channel-content-bulk'
import type { ChannelFieldSelection } from '@/lib/api/channel-content-bulk'

export function useChannelCredits(productIds: string[], selections: ChannelFieldSelection[]) {
  const selectionKey = selections
    .map((s) => `${s.attribute_code}:${s.template_id ?? ''}:${s.system_tool_code ?? ''}`)
    .sort()
    .join('|')

  const { data, isLoading } = useQuery({
    queryKey: ['channel-content-estimate', selections[0]?.channel_id, productIds.length, selectionKey],
    queryFn: () => estimateRun({ product_ids: productIds, channel_field_selections: selections }),
    enabled: productIds.length > 0 && selections.length > 0,
    staleTime: 30_000,
  })

  return {
    credits: data?.credits_estimated ?? null,
    texts: selections.length * productIds.length,
    isLoading,
  }
}
